<details class="setup-row documentation-details">
    <summary class="setup-row-summary">
        <i class="fa fa-chevron-right details-chevron" aria-hidden="true"></i>
        <span class="setup-row-icon" aria-hidden="true"><i class="fa fa-folder-o"></i></span>
        <span class="setup-row-copy">
            <span class="setup-row-title">
                Documentation
                <i class="fa fa-question-circle help-icon"
                aria-hidden="true"
                matTooltip="Upload your project documents (e.g., ethical approval, data management plan, project application). The documents are stored in the Documents folder on your project server."
                ></i>
            </span>
            <span class="setup-row-subtitle">Data management plan, ethics approval and other project documents</span>
        </span>
        <!--Only files added in this dialog are known here; documents stored earlier aren't listed-->
        <span class="setup-row-badge" *ngIf="docFiles.value.length > 0">
            {{ docFiles.value.length }} to upload
        </span>
    </summary>

    <div class="documentation-content">
        <ngx-dropzone [expandable]="true" (change)="onUpload($event)">
            <ngx-dropzone-label>Drop any documents you might have here, such as your data management plan and ethics approval.</ngx-dropzone-label>
            <ngx-dropzone-preview *ngFor="let f of docFiles.value" [removable]="true" (removed)="onRemove(f)">
                <ngx-dropzone-label>
                    <i class="fa fa-file-o" aria-hidden="true"></i>
                    &nbsp;{{ f.name }}
                    <img *ngIf="f.uploadComplete == false" class="loading-indicator" src="assets/loading-indicator.svg">
                </ngx-dropzone-label>
            </ngx-dropzone-preview>
        </ngx-dropzone>
    </div>
</details>
